import { FC } from 'react';
import { Badge, Text } from '../../../shared/uiComponents';
import { InsuranceDetailProperties } from '../../../redux/API/ClientAPIHelpers/insuranceProperties';
import { SESSION_TYPE_LABELS } from '../../../shared/Helpers/constants';

interface TelehealthCardProps {
	insurance: InsuranceDetailProperties;
}

const TelehealthCard: FC<TelehealthCardProps> = ({ insurance }) => (
	<div className="insuranceDetailCard">
		<Text title="Telehealth Settings" type="h6" fontWeight="semiBold" />
		<div style={{ marginTop: '20px' }}>
			<div className="insuranceDetailInfoRow">
				<Text title="Allow Telehealth:" type="psm" fontWeight="semiBold" />
				<Badge
					label={insurance.allowTelehealth ? 'Yes' : 'No'}
					type={insurance.allowTelehealth ? 'success' : 'gray'}
					sizeType="sm"
				/>
			</div>

			{insurance.allowTelehealth && insurance.telehealthSessionTypes?.length > 0 && (
				<div className="insuranceDetailInfoRow" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: '8px' }}>
					<Text title="Allowed Session Types:" type="psm" fontWeight="semiBold" />
					<div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
						{insurance.telehealthSessionTypes.map((type) => (
							<Badge
								key={type}
								label={SESSION_TYPE_LABELS[type] ?? `Type ${type}`}
								type="success"
								sizeType="sm"
							/>
						))}
					</div>
				</div>
			)}

			{insurance.allowTelehealth && (!insurance.telehealthSessionTypes || insurance.telehealthSessionTypes.length === 0) && (
				<div className="insuranceDetailInfoRow">
					<Text title="Allowed Session Types:" type="psm" fontWeight="semiBold" />
					<Badge label="All Session Types" type="success" sizeType="sm" />
				</div>
			)}
		</div>
	</div>
);

export default TelehealthCard;
